<template>
  <div v-if="masterCampaign">
    <vx-card no-shadow>
      <h2>Email Template</h2>
      <h5 class="my-5" v-if="!isEditable">
        <b
          >Note: Can no longer be edited as campaign has status
          {{ masterStatusObject(masterCampaign.masterStatus).text }}.</b
        >
      </h5>

      <!-- <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Content type</span>
        </div>
        <div class="vx-col sm:w-2/5">
          <vs-select class="selectExample" label="Marketing type" v-model="template.consent_type">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in consentTypeOptions"
            />
          </vs-select>
        </div>
      </div> -->

      <div class="col-8 mb-5">
        <p class="mb-0">
          This is a master campaign email template. The logo, background-, text-, button background- and
          button text-color <br />
          will automatically be adjusted to match the individual design of the assigned venues.
          <br />
        </p>
        <p class="mt-2 mb-4">
          You can specify dynamic content by using the <b>Merge Tags</b> feature in the mail editor.<br />
        </p>
      </div>

      <div class="vx-row mt-4 mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Email subject</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full max-w-xl">
          <vs-input
            :placeholder="'Mail from {{venue_name}}'"
            v-model="masterCampaign.emailSubject"
            class="w-full"
          />
        </div>
      </div>

      <email-template-editor :email-json="masterCampaign.emailJson" ref="emailEditor" />

      <!-- Save & Remove Button -->
      <vs-row vs-justify="flex-end" class="flex flex-wrap items-center" style="margin-top: 32px">
        <vs-button v-if="isEditable && $AuthService.hasPermissionForActiveVenue('vp.crm.campaigns.edit')" id="save-button" @click="onClickSave" class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import EmailTemplateEditor from "@/components/EmailTemplateEditor/EmailTemplateEditor.vue";
import campaignMixin from "@/views/mixins/campaignMixin";

export default {
  components: {
    EmailTemplateEditor,
  },
  mixins: [campaignMixin],
  props: ["masterCampaign", "isEditable"],
  computed: {
    ...mapGetters({
      consentTypes: "templates/consentTypes",
    }),
    consentTypeOptions() {
      return this.consentTypes.map((e, i) => {
        return { text: e, value: i };
      });
    },
  },
  methods: {
    async onClickSave() {
      const emailExport = await this.$refs.emailEditor.export();

      this.masterCampaign.emailJson = JSON.stringify(emailExport.design);

      this.$emit("onSave");
    },
  },
};
</script>

<style lang="scss">
</style>